import { useEffect, useState } from "react";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { CustomerData, LedgerDetails } from "src/shared/services/interfacev2";
import { getLedgerByCustomer, putLedgerByCustomer } from "src/shared/services/servicesv2";

export const useLedger = (customer: CustomerData | null) => {
  const [ledger, setLedger] = useState<LedgerDetails | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchLedger = async (customerId: string) => {
    setLoading(true);
    getLedgerByCustomer(customerId)
      .then((res) => {
        setLedger(res.data.ledger); // ✅ API already returns LedgerDetails
      })
      .catch(() => {
        // ✅ fallback with CORRECT SHAPE
        setLedger({
          orgId: 0,
          refId: 0,
          totalOutstandingBalance: 0,
          customerDetails: {
            firstName: "",
            middleName: "",
            lastName: "",
            phones: [],
            emails: [],
            refId: 0
          },
          orderDetails: [],
          orderHistory: [],
        });
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (!customer?._id?.$oid) return;

    setLoading(true);
    fetchLedger(customer._id.$oid);


  }, [customer]);

  const updatesLedgerLimit = (customerId: string, newLimit: number) => {
    setLoading(true);
    putLedgerByCustomer(customerId, { creditLimit: { defaultLimit: newLimit } })
      .then(() => {
        notifySuccess("Credit limit updated successfully.");
        fetchLedger(customerId); // ✅ Refresh ledger data after update
      }).catch((error) => {
        notifyError(error || "Failed to update credit limit.");
        setLoading(false);
      });
  };

  return { ledger, loading, updatesLedgerLimit };
};
